import { doMutation } from "../../core-module/util/graphqlHelper";

export const approveOrRejectQuizContent = ({ id, approvalStatus }) => {
  const mutation = require("../api/mutation/approveOrRejectQuizContent.gql");
  const variables = { id, approvalStatus };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      return { data: data.approveOrRejectQuizContent };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
